/* eslint-disable consistent-return */
import { Alert, Col, Layout, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";
import { useNavigate, useLocation } from "react-router-dom";

import { getSupaClient } from "../../lib/supabase";
import animationData from "../../lottie/loading-people-magnify.json";
import DotsFishLoading from "../DotsFishLoading/DotsFishLoading";
import { setOnboardingStatus } from "../Onboarding/Onboarding";

const queryString = require("query-string");

const { Content } = Layout;

const SlackAdded = (props) => {
  const supabase = getSupaClient();
  const [loading, setLoading] = useState(true);
  const [almostThere, setAlmostThere] = useState(false);
  const [slackError, setSlackError] = useState(false);
  const [databaseError, setDatabaseError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const slackCode = queryString.parse(location.search).code;

  /**
   * Set team-id, team-name and slack-id in local storage. Also, refresh the current supabase
   * session so that workspace is added to app_metadata for a new user that just "added to Slack"
   * @param {Object} data : data returned from a successful call to /addtoslack
   */
  const setLocalStorage = (data) => {
    supabase.auth.refreshSession();
    localStorage.setItem("platform", "slack");
    localStorage.setItem("team-id", data.team.slack_id);
    localStorage.setItem("team-name", data.team.name);
    const appUser = data.appUser[0] ?? data.appUser; // For some reason appUser is an array here
    localStorage.setItem("slack-id", appUser.slack_id);
  };

  const setIdentifiers = (data) => {
    window.analytics.identify(`${data.team.name}-${data.appUser.slack_id}`);
    window.posthog.identify(`${data.team.name}-${data.appUser.slack_id}`);

    window.analytics.track("Signed up", {
      slackId: `${data.appUser.slack_id}`,
      teamId: `${data.team.id}`,
    });
    window.posthog.capture("Signed up");
    window.analytics.track("Slack Added", {
      slackId: `${data.appUser.slack_id}`,
      teamId: `${data.team.id}`,
    });
  };

  const handleRedirect = async () => {
    const response = await fetch(`${process.env.REACT_APP_API}/addtoslack`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        slackCode,
        reactAppURI: `${process.env.REACT_APP_URI}/auth/added/`,
        supaUser: supabase.auth.user(),
      }),
    });
    const { data, error } = await response.json();
    setLoading(false);
    if (error) {
      console.log("error from /addtoslack", error);
      if (error === "slack_error") setSlackError(true);
      if (error === "database_error") setDatabaseError(true);
      return;
    } else {
      const user = supabase.auth.user();
      setOnboardingStatus(user?.email, "onboarded");
      window.analytics.track("Sign up - Slack onboarded");
    }
    await setLocalStorage(data);
    await setIdentifiers(data);

    if (!data.teamExisted) {
      // team doesn't exist
      setTimeout(async function () {
        return navigate("/home");
      }, 30000);
      setTimeout(function () {
        setAlmostThere(true);
      }, 20000);
    } else {
      setTimeout(function () {
        return navigate("/home");
      }, 1000);
    }
  };
  // load once
  useEffect(() => {
    handleRedirect();
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Content align="middle" style={{ minHeight: "100vh" }}>
      <Spin spinning={loading}>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ minHeight: "100vh" }}
        >
          <Col span={12}>
            <div>
              {slackError ? (
                <Alert
                  message="Slack Error"
                  description="We got an error trying to add Dots to your Slack. Please contact hello@dots.community."
                  type="error"
                  showIcon
                />
              ) : null}
            </div>
            <div>
              {databaseError ? (
                <Alert
                  message="Database error"
                  description="We experienced an error setting up your account. Please contact hello@dots.community."
                  type="error"
                  showIcon
                />
              ) : null}
            </div>
            {/* <img alt="Pulling data" src="/teaching.png" width="300" /> */}
            <Lottie options={defaultOptions} width={400} />
            <h2>
              Beginning to pull public channel data...be ready in 30 secs!
            </h2>
            <h2>
              Pulling the last 30 days of activity for your Dots trial. If you
              want to look at older historical data, please reach out to{" "}
              <a href="mailto:hello@dots.community">hello@dots.community</a> to
              upgrade.{" "}
            </h2>
            {almostThere ? (
              <h2>
                Crunching metrics...almost there! Redirecting you shortly...
              </h2>
            ) : (
              ""
            )}
            <DotsFishLoading />
          </Col>
        </Row>
      </Spin>
    </Content>
  );
};

export default SlackAdded;
